import type { HeaderMenuItem } from './types';

export function hasChildren(item?: HeaderMenuItem | null): boolean {
  return Boolean(item?.children && item.children.length > 0);
}
